// extracted by mini-css-extract-plugin
module.exports = {"table":"Report__table--1_cqf","category":"Report__category--1VUHs","name":"Report__name--1ukD0","limit":"Report__limit--2fhdX"};